import { smoothScrollToPosition } from './smoothScrollToPosition';

/**
 * Возвращает Promise, который резолвится по завершению скролла до `top`
 * или по истечению `timeout`.
 *
 * Используется, когда вызов обычного `smoothScrollToPosition` может быть прерван
 * изменениями в DOM.
 * Например, в пагинации при переходе на новую страницу данные могут загрузиться
 * и отрендериться быстрее, чем закончится скролл. В этом случае скролл остановится
 * где-то по середине пути.
 */
export const smoothScrollToPositionAsync = async (top: number = 0, timeout: number = 1000) => {
  return new Promise(resolve => {
    smoothScrollToPosition(top);

    let isTimeout = false;
    setTimeout(() => (isTimeout = true), timeout);

    const requestId = window.requestAnimationFrame(checkScrollEnd);

    function checkScrollEnd() {
      if (isTimeout) {
        window.cancelAnimationFrame(requestId);
        resolve(false);
      } else if (window.scrollY > top) {
        window.requestAnimationFrame(checkScrollEnd);
      } else {
        resolve(true);
      }
    }
  });
};
